"use strict"
const get_relations = (data, outputs) => {
  var res = {};
  for(let i = 0; i < outputs.length; i++){
    res[outputs[i].name] = JSON.parse(JSON.stringify(data[i]));
    for(let obj of res[outputs[i].name]){
      if(outputs[i].relations && outputs[i].relations.length > 0){
        for(let relation of outputs[i].relations){
          process_relation(obj, relation, data, outputs);
        }
      }
    }
  }
  return res;
}
  
let process_relation = (obj, relation, data, outputs) => {
  try{
    let arr_from = relation.from.split('.');
    let arr_to = relation.to.split('.');
    let index = outputs.findIndex(output => output.name == arr_to[0]);
    if(index !== -1){
      let aux = data[index].filter(k => k[arr_to[1]] == obj[arr_from[1]]);
      obj[relation.name] = aux?aux:[];
      if(obj[relation.name].length > 0 && (outputs[index].relations && outputs[index].relations.length > 0)){
        for(let rel of outputs[index].relations){
          for(let o of obj[relation.name]){
            process_relation(o, rel, data, outputs);
          }
        }
      }
    }else{
      console.log(`output table not found ${arr_to[0]}`);
    }
  }catch(err){
    console.log(err);
  }
}

module.exports = get_relations;